











import Vue from 'vue';
import TheNavigation from '@/components/TheNavigation.vue';

import 'material-icons';
import '@/assets/styles/main.css';
import { IS_PROD } from '@/assets/src/configs';

export default Vue.extend({
  name: 'app',

  components: { TheNavigation },

  data() {
    return {
      is_prod: IS_PROD,
    };
  },
});
